import "./assets/css/app.css";
import "./assets/toastr/toastr.css";
import _Header from "./layouts/Header";
import { useEffect } from "react";
import _Nav from "./layouts/_Nav";
import MainLayouts from "./layouts/MainLayouts";
import Forms from "./pages/Forms";
import "./assets/font/font.css"
import Routing from "./routing/routing";
import "./App.less"
import "./assets/css/home.less"
import "./assets/css/style.css"
import 'toastr/build/toastr.min.css'
import useSessionTimeout from "components/sessionTimeOut";
import { LogOut } from "auth";

 



function App() {

  useSessionTimeout(LogOut);
  
  // useSessionTimeout(logout);
  return (

    <Routing />
    
    // <Routing />
    // <MainLayouts>
    //   {/* <Forms /> */}
    // </MainLayouts>
  );
}

export default App;
